import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: 'flex',
      flex: '1',
      paddingLeft: theme.spacing(1),
    },
    brdBtm: {
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
      padding: theme.spacing(2, 0),
      pageBreakInside: 'avoid',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    labelCol: {
      width: '25%',
      marginRight: theme.spacing(3),
    },
    flexGrow: {
      flex: '1',
    },
    marginLeft: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    marginBottomLarge: {
      marginBottom: theme.spacing(2),
    },
    marginTop: {
      marginTop: theme.spacing(1),
    },
    typographyFontSize: {
      fontSize: '14px',
    },
    bold: {
      fontWeight: 'bold',
    },
    infoAlert: {
      alignItems: 'center',
      background: '#F5F5F5',
      color: '#616161',
      borderColor: '#EEEEEE',
      '& .MuiAlert-action': {
        display: 'unset',
        minWidth: 'fit-content',
      },
    },
    retryText: {
      color: theme.palette.error.main,
    },
  }),
);

export default useStyles;
